export function useMessageAPI() {
  const { errors, request } = useRequest();

  async function fetchMessagesForFitter(fitterId: number) {
    return await request<MessageDTO[]>(`${versionedUrl('Message/ForFitter')}?fitterId=${fitterId}`);
  }

  async function markMessageAsRead(messageId: number) {
    const requestOptions: RequestOptions = {
      method: 'POST'
    };

    return await request<boolean>(`${versionedUrl('Message/MarkAsRead')}?messageId=${messageId}`, requestOptions);
  }

  async function markAllUnreadAsRead(fitterId: number) {
    const requestOptions: RequestOptions = {
      method: 'POST'
    };

    return await request<boolean>(`${versionedUrl('Message/MarkAllUnreadAsRead')}?fitterId=${fitterId}`, requestOptions);
  }

  async function deleteMessage(messageId: number) {
    const requestOptions: RequestOptions = {
      method: 'DELETE'
    };

    return await request<boolean>(`${versionedUrl('Message/Delete')}?messageId=${messageId}`, requestOptions);
  }

  return {
    errors,
    fetchMessagesForFitter,
    markMessageAsRead,
    markAllUnreadAsRead,
    deleteMessage
  };
}
